module.exports = __webpack_public_path__ + "static/media/chloegourmet.6fbdcf08.jpg";